import { Updatable } from '../../..';

export default class FondySettings extends Updatable {
    public merchantId: number;
    public secretKey: string;

    update(entity: Partial<FondySettings>, allowUndefined = false) {
        super.update(entity, allowUndefined);
    }
}